// Set in PHP SB_Chat Class.
declare const chatConfig: {
	isStaging?: boolean;
	preventAutopop?: boolean;
	autopopDelay?: number;
};

// Declare sb_chat function
declare function sb_chat(params: ChatParams): void;

// Defined in external chat script - https://ccc.sonobello.com/sb-chat/sb-chat.js
interface ChatParams {
	p1?: string;
	p2?: string;
	p3?: string;
	p4?: string;
	p5?: string;
	p6?: string;
	p7?: string;
	p8?: string;
	p9?: string;
	poc?: string;
	auto_pop?: boolean;
	float_button?: boolean;
}

// Define chat params.
const chatParams: ChatParams = {
	p5: '14',
	// eslint-disable-next-line camelcase
	auto_pop: false,
	// eslint-disable-next-line camelcase
	float_button: false,
};

declare let dbUser: {
	Lead_fname?: string;
	Lead_lname?: string;
	lead_email?: string;
	lead_homephone?: string;
	Camp_ID?: string;
	lead_postal?: string;
};

// Detect touch devices and add body classes.
const isTouchDevice =
	'ontouchstart' in window ||
	(navigator.maxTouchPoints !== undefined && navigator.maxTouchPoints > 0);

if (isTouchDevice) {
	document.body.classList.add('is-mobile-device');

	const ua = navigator.userAgent;
	const isIpad =
		(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0) || /iPad/.test(ua);
	const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua);

	if (isIpad) {
		document.body.classList.add('is-tablet', 'is-ipad');
	} else if (isAndroidTablet) {
		document.body.classList.add('is-tablet', 'is-android-tablet');
	} else if (/iPhone|iPod/.test(ua)) {
		document.body.classList.add('is-phone', 'is-iphone');
	} else if (/Android/i.test(ua)) {
		document.body.classList.add('is-phone', 'is-android');
	} else {
		document.body.classList.add('is-phone');
	}
}

if (typeof dbUser !== 'undefined') {
	if (dbUser.Lead_fname && dbUser.Lead_lname) {
		chatParams.p1 = `${dbUser.Lead_fname}|${dbUser.Lead_lname}`;
	}
	if (dbUser.lead_email) {
		chatParams.p2 = dbUser.lead_email;
	}
	if (dbUser.lead_homephone) {
		chatParams.p3 = dbUser.lead_homephone;
	}
	if (dbUser.Camp_ID) {
		chatParams.p5 = dbUser.Camp_ID;
	}
	if (dbUser.lead_postal) {
		chatParams.p8 = dbUser.lead_postal;
	}
}

// Set staging POC.
if (false !== chatConfig.isStaging) {
	chatParams.poc = 'afb7d6c3-0450-47d8-b64e-f57b3a052cc7';
}

// Initiate chat.
sb_chat(chatParams);

// Chat popup display variable name.
const chatSessionDisplayKey = 'onPagePreventAutopop';

// Function to set the page prevent auto-pop value
const setPagePreventAutopop = function (autopopValue: boolean): void {
	if (true === autopopValue) {
		sessionStorage.setItem(chatSessionDisplayKey, 'true');
	} else {
		sessionStorage.removeItem(chatSessionDisplayKey);
	}
};

// Event listener for the chat launch button.
document.addEventListener('click', function (event: Event) {
	const target = event.target as HTMLElement;
	if (target && target.classList.contains('sb-di-chat-launch-chat')) {
		setPagePreventAutopop(true);
	}
});

// Function to show the chat wrapper.
function showChatWrapper() {
	const chatWrapper = document.querySelector('.sb-di-chat-button-wrapper') as HTMLElement;
	if (chatWrapper && 'true' !== sessionStorage.getItem(chatSessionDisplayKey)) {
		chatWrapper.style.display = 'block';
	}
}

const preventAutopop =
	chatConfig.preventAutopop ||
	(window as unknown as { sbPreventAutopop?: boolean }).sbPreventAutopop === true;

// Only set timeout if the context allows.
if (!preventAutopop && 'true' !== sessionStorage.getItem(chatSessionDisplayKey)) {
	setTimeout(showChatWrapper, chatConfig.autopopDelay);
}

// Handle close chat popup from close button.
document.addEventListener('click', function (event: Event) {
	const target = event.target as HTMLElement;
	if (target && target.classList.contains('sb-chat-close')) {
		event.preventDefault();
		const chatWrapper = document.querySelector('.sb-di-chat-button-wrapper') as HTMLElement;
		chatWrapper.style.display = 'none';
		setPagePreventAutopop(true);
	}
});

// Add event listener to the body for clicks on the chat launch button.
document.body.addEventListener('click', function (event: Event) {
	const target = event.target as HTMLElement;
	if (target && target.classList.contains('sb-di-chat-launch-chat')) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'Open Chat',
			label: 'Open Chat',
			category: 'ui',
		});
	}
});
